import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SaveCharacter } from '../../redux/actions/myAccountAction'
import NotificationBox from '../../containers/form/NotificationBox'
import ChangeCharacterModal from '../../containers/modal/change-character-modal'
import { characterConst } from '../../utils/constant'
import { AppUseSelector } from '../../redux/hooks'
import { SettingsOption, SettingsSection } from './SettingsSection'

const characterOptions = [characterConst.simplified, characterConst.traditional]

// The stored values ('Simplified', 'Traditional') are codes; their labels are settings:characters.*.
const characterLabelKey = (option: string) =>
  option === characterConst.traditional ? 'settings:characters.traditional' : 'settings:characters.simplified'

const CharacterSection = ({ id }: { id?: string }) => {
  const { t } = useTranslation('settings')
  const { customFields = {}, character = characterConst.simplified } = AppUseSelector(
    (state: any) => state.user.credentials,
  )
  const currentCharacter: string = customFields.character || character || ''
  const [nextCharacter, setNextCharacter] = useState('')
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [notify, setNotify] = useState({ label: '', isError: false })

  const clearNotify = () => setNotify({ label: '', isError: false })

  const askToChange = (option: string) => {
    clearNotify()
    setNextCharacter(option)
    setIsOpenModal(true)
  }

  const handleUpdateCharacter = (updateCharacter: string) => {
    if (updateCharacter === currentCharacter || isUpdating) return
    setIsUpdating(true)
    SaveCharacter({ UpdateCharacter: updateCharacter })
      .then(() => setNotify({ label: t('characters.saved'), isError: false }))
      .catch((e) => setNotify({ label: e || t('characters.saveError'), isError: true }))
      .finally(() => {
        setIsUpdating(false)
        setIsOpenModal(false)
      })
  }

  return (
    <SettingsSection id={id} title={t('characters.title')}>
      <NotificationBox clearNotify={clearNotify} {...notify} />
      <div className='settings-options'>
        {characterOptions.map((option) => (
          <SettingsOption
            key={option}
            type='radio'
            name='character'
            label={t(characterLabelKey(option))}
            checked={currentCharacter === option}
            disabled={isUpdating}
            onChange={() => askToChange(option)}
          />
        ))}
      </div>
      <ChangeCharacterModal
        show={isOpenModal}
        onHide={() => setIsOpenModal(false)}
        fromCharacter={currentCharacter}
        toCharacter={nextCharacter}
        onConfirm={handleUpdateCharacter}
        isUpdating={isUpdating}
      />
    </SettingsSection>
  )
}

export default CharacterSection
